<template>
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template v-slot:body>
          <div class="row">
                    <div class="col-md-3">
                      <div class="mb-3">
                          <ElLabel name="회계년도">
                  <template #end>
                    <ElSelect v-model="state.searchParams.fs_year" :options="revList.map(item => ({text: `${item.year}년`, value: item.year}))"/>
                  </template>
                </ElLabel>
                      </div>
                    </div>
                  </div>
            <div class="table-responsive table-list">
                <TreeTable
                    ref="treeTableRef"
                    v-bind="treeGridProps"
                />
            </div>
        </template>
    </BaseModal>
</template>
<script setup>
import { ref,onBeforeMount,reactive,watch } from 'vue';
import { getQuotaProdRevIdList, prodList } from '@/api/prod';
import BaseModal from '@/components/common/modal/BaseModal.vue';
import TreeTable from '../TreeTableModal.vue';
import { useLoading } from '@/composable/Loading.js'
import common from '@/js/common';


const props = defineProps({
  fs_year: {
    type: [String, Number],
    default: ''
  },
  maxRev:{
    type:String,
    default: ''
  },
  action_flag:{
    type: String,
    default: 'Y' //y:등록,n 수정 화면
  }
})

const { setIsLoading } = useLoading()
const emits = defineEmits(['return'])
const baseModalRef = ref()
const treeTableRef = ref()
onBeforeMount(async()=>{
    await getYear();
    await getRevList();
    await getProdList();
})

const childProps = ref({
    modalId : 'prodModal',
    modalNm : '상품조회',
    size:'xl',
    btnList : [
        {name : '선택' , classNm : 'search', function : selectData}
    ]
})

const treeGridProps = ref({
  gridColumn : [
    {
      header: "상품명",
      field: "class_nm",
      expander: true,
      style: { minWidth: "200px",maxWidth:'200px' },
    },
    { header: "활성화 여부", field: "enable_yn", style: { minWidth: "100px",maxWidth:'100px' } },
    { header: "메모", field: "note", style: { minWidth: "250px",maxWidth:'250px' } },
    { header: "등록일", field: "fmt_reg_dt", style: { minWidth: "200px" } },
    { header: "등록자", field: "reg_user_nm", style: { minWidth: "100px" } },
    { header: "수정일", field: "fmt_upd_dt", style: { minWidth: "200px" } },
    { header: "수정자", field: "upd_user_nm", style: { minWidth: "100px" } },
  ],
    dataList : [],
    editable :false,
    rootVal : '',
    useCheckBox : false,
    selectType : 'single'
})

const revList = ref([])
const recentProdRev = ref('')
const yearsList = ref([]);

const state = reactive({
  ceoList : [],

  searchParams : {
      fs_year : '',
      page_count : 1,
      unit_count : 100000,
      sales_ceo : ''
  },
  format:'yyyy',
  nodata: false
})

function openModal(){
    baseModalRef.value.openModal()
}

function closeModal(){
    baseModalRef.value.closeModal()
}

async function getYear() {
  
  const currYear = new Date().getFullYear();
  state.searchParams.fs_year = props.fs_year || String(currYear);

}


//상품분류 리비전 목록 조회
async function getRevList(){
  try {
    setIsLoading(true)
    const res = await getQuotaProdRevIdList()
    revList.value = res.rtn
    props.action_flag ==='N'? recentProdRev.value = props.maxRev : recentProdRev.value =  res.rtn.find((item) => item.year == state.searchParams.fs_year)?.rev_id
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};

//상품분류 조회
async function getProdList(){
   props.action_flag ==='N'? recentProdRev.value = props.maxRev : recentProdRev.value =   revList.value.find((item) => item.year == state.searchParams.fs_year)?.rev_id
  
   // recentProdRev.value =  revList.value.find((item) => item.year == state.searchParams.fs_year)?.rev_id
  let param = {
    rev_id : recentProdRev.value
  }

  // recentProdRev.value = param.rev_id
  try {
    setIsLoading(true)
    const res = await prodList(param)
    treeGridProps.value.dataList = res.rtn.map((item)=>{
      if(item.enable_yn == 'Y'){
        return item
      }else{
        return ''
      }
      
    });
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}
watch(
  () => state.searchParams.fs_year,
  (newYear, oldYear) => {
    if (newYear !== oldYear) {
      getProdList();
      if(isRevIdDifferent(revList.value,props.fs_year,state.searchParams.fs_year)){
        alert('상품분류의 회계연도와 매출회계연도가 일치하지 않습니다.')
        state.searchParams.fs_year = props.fs_year
        return
      }
    }
  }
);

watch(
  () => props.fs_year,
  (newYear, oldYear) => {
    if (newYear !== oldYear) {
      getYear();
    }
  }
);


function isRevIdDifferent(revList, aYear, bYear) {
    const aRevItem = revList.find(item => item.year === aYear);
    const aRevId = aRevItem ? aRevItem.rev_id : null;

    const bRevItem = revList.find(item => item.year === bYear);
    const bRevId = bRevItem ? bRevItem.rev_id : null;
    if (aRevId && bRevId) {
        return aRevId !== bRevId;
    }
    return false;
}

function selectData(){
    
    if(!treeTableRef.value.selectionKeys){
      alert('선택된 행이 없습니다.')
    }else{
      let selectKey = Object.keys(treeTableRef.value.selectionKeys)[0]
      let rtn
      let codeFam = [...common.findUperCode(selectKey,treeGridProps.value.dataList)]

      rtn = {
          selectKey : selectKey,
          codeFam : codeFam,
          rev_id : recentProdRev.value
      }
      emits('return',rtn)

    }
   

    closeModal()
    
}

defineExpose({
    openModal
})
</script>